<template>
  <div class="wg-row">
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Company name", "Nome azienda") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="com-anm22-app-input-text"
            type="text"
            v-model="objData.name"
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Email", "Email") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="com-anm22-app-input-text"
            type="text"
            v-model="objData.email"
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Email 2", "Email 2") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="com-anm22-app-input-text"
            type="text"
            v-model="objData.email2"
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Email 3", "Email 3") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="com-anm22-app-input-text"
            type="text"
            v-model="objData.email3"
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Phone 1", "Telefono 1") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <div class="wg-col wg-xs-4 wg-sm-4" style="max-width: 100px">
            <select
              class="com-anm22-app-select"
              v-model="objData.phoneAreaCode"
            >
              <option
                v-for="(
                  obj, key, index
                ) in $anm22.tableClasses.areaCode().getAll()"
                :key="'areaCode-' + index"
                :value="key"
              >
                {{ obj[lang] }}
              </option>
            </select>
          </div>
          <div class="wg-col wg-xs-8 wg-sm-8" style="max-width: 200px">
            <input
              class="com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Number', 'Numero')"
              v-model="objData.phoneNumber"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Phone 2", "Telefono 2") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <div class="wg-col wg-xs-4 wg-sm-4" style="max-width: 100px">
            <select
              class="com-anm22-app-select"
              v-model="objData.phoneAreaCode2"
            >
              <option
                v-for="(
                  obj, key, index
                ) in $anm22.tableClasses.areaCode().getAll()"
                :key="'areaCode-' + index"
                :value="key"
              >
                {{ obj[lang] }}
              </option>
            </select>
          </div>
          <div class="wg-col wg-xs-8 wg-sm-8" style="max-width: 200px">
            <input
              class="com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Number', 'Numero')"
              v-model="objData.phoneNumber2"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Phone 3", "Telefono 3") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <div class="wg-col wg-xs-4 wg-sm-4" style="max-width: 100px">
            <select
              class="com-anm22-app-select"
              v-model="objData.phoneAreaCode3"
            >
              <option
                v-for="(
                  obj, key, index
                ) in $anm22.tableClasses.areaCode().getAll()"
                :key="'areaCode-' + index"
                :value="key"
              >
                {{ obj[lang] }}
              </option>
            </select>
          </div>
          <div class="wg-col wg-xs-8 wg-sm-8" style="max-width: 200px">
            <input
              class="com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Number', 'Numero')"
              v-model="objData.phoneNumber3"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Website", "Sito web") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="com-anm22-app-input-text"
            type="text"
            v-model="objData.website"
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Address (Place)", "Indirizzo (Sede)") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <div class="wg-col wg-xs-8 wg-sm-8" style="max-width: 200px">
            <input
              class="com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
              v-model="objData.addressStreet"
            />
          </div>
          <div class="wg-col wg-xs-4 wg-sm-4" style="max-width: 100px">
            <input
              class="com-anm22-app-input-text"
              type="text"
              placeholder="N."
              v-model="objData.addressNumber"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "City", "Città") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            :placeholder="$anm22.strLang(lang, 'City', 'Città')"
            v-model="objData.addressCity"
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "ZIP", "CAP") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            :placeholder="$anm22.strLang(lang, 'ZIP', 'CAP')"
            v-model="objData.addressZip"
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "State (Abbreviation)", "Provincia (Sigla)") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            :placeholder="$anm22.strLang(lang, 'State (Abbreviation)', 'Provincia (Sigla)')"
            v-model="objData.addressState"
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Country", "Paese") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <select
            class="input-elem com-anm22-app-select"
            v-model="objData.addressCountry"
          >
            <option value selected disabled hidden>
              {{ $anm22.strLang(lang, "Select", "Seleziona") }}
            </option>
            <option
              v-for="obj in Object.values(
                $anm22.tableClasses.worldCountry().getAll()
              ).sort((a, b) =>
                a[lang] < b[lang] ? -1 : b[lang] > b[lang] ? 1 : 0
              )"
              :key="'country-' + obj.typeClassLiteral"
              :value="obj.typeClassLiteral"
            >
              {{ obj[lang] }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height: 15px"></div>
    <div class="wg-row">
      <input
        type="button"
        class="small"
        :style="{ opacity: canGenerateContract ? '' : '0.6' }"
        :disabled="!canGenerateContract"
        :value="
          $anm22.strLang(
            lang,
            'Save and generate contract',
            'Salva e genera contratto'
          )
        "
        @click="save"
      />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { mapState } from "vuex";
export default {
  props: {
    contact: Object
  },
  data() {
    return {
      objData: {
        name:"",
        email:"",
        email2:"",
        email3:"",
        website:"",
        phoneAreaCode:"",
        phoneAreaCode2:"",
        phoneAreaCode3:"",
        phoneNumber:"",
        phoneNumber2:"",
        phoneNumber3:"",
        addressStreet:"",
        addressNumber:"",
        addressCity:"",
        addressZip:"",
        addressState:"",
        addressCountry:"",
      }
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
      offline: (state) => state.offline.isOffline
    }),
    canGenerateContract() {
      let canGenerate = true;
      if (!this.objData.name || this.objData.name == "") {
        canGenerate = false;
      }
      if (!this.objData.addressStreet || this.objData.addressStreet == "") {
        canGenerate = false;
      }
      if (!this.objData.addressCity || this.objData.addressCity == "") {
        canGenerate = false;
      }
      if (!this.objData.addressZip || this.objData.addressZip == "") {
        canGenerate = false;
      }
      if (!this.objData.addressState || this.objData.addressState == "") {
        canGenerate = false;
      }
      if (!this.objData.addressCountry || this.objData.addressCountry == "") {
        canGenerate = false;
      }
      if (
        (!this.objData.email || this.objData.email == "") &&
        (!this.objData.email2 || this.objData.email2 == "") &&
        (!this.objData.email3 || this.objData.email3 == "")
      ) {
        canGenerate = false;
      }
      let phone1 = null;
      let phone2 = null;
      let phone3 = null;
      if (this.objData.phoneAreaCode == "" || this.objData.phoneNumber == "") {
        phone1 = null;
      } else {
        phone1 = this.objData.phoneAreaCode + this.objData.phoneNumber;
      }
      if (
        this.objData.phoneAreaCode2 == "" ||
        this.objData.phoneNumber2 == ""
      ) {
        phone2 = null;
      } else {
        phone2 = this.objData.phoneAreaCode2 + this.objData.phoneNumber2;
      }
      if (
        this.objData.phoneAreaCode3 == "" ||
        this.objData.phoneNumber3 == ""
      ) {
        phone3 = null;
      } else {
        phone3 = this.objData.phoneAreaCode3 + this.objData.phoneNumber3;
      }
      if (!phone1 && !phone2 && !phone3) {
        canGenerate = false;
      }
      return canGenerate;
    }
  },
  methods: {
    save() {
      if (this.contact.type == 2) {
        this.contact.firstName = this.objData.name;
      } else {
        this.contact.company = this.objData.name;
      }
      if (this.objData.website && this.objData.website != "") {
        this.contact.website = this.objData.website;
      }
      this.contact.phoneAreaCode = this.objData.phoneAreaCode;
      this.contact.phoneNumber = this.objData.phoneNumber;
      this.contact.email = this.objData.email;
      /* Creazione oggetto altre informazioni se non esistente */
      if (
        !this.contact.otherInformations ||
        this.contact.otherInformations.length == 0
      ) {
        this.contact.otherInformations = {};
      }
      if(!this.contact.otherInformations.beachDimension) {
        this.contact.otherInformations.beachDimension = "";
      }
      this.contact.otherInformations.addressStreet = this.objData.addressStreet;
      this.contact.otherInformations.addressNumber = this.objData.addressNumber;
      this.contact.otherInformations.addressCity = this.objData.addressCity;
      this.contact.otherInformations.addressZip = this.objData.addressZip;
      this.contact.otherInformations.addressState = this.objData.addressState;
      this.contact.otherInformations.addressCountry = this.objData.addressCountry;

      /* Creazione oggetto altri contatti se non esistente */
      if (
        !this.contact.otherContacts ||
        this.contact.otherContacts.length == 0
      ) {
        this.contact.otherContacts = {};
      }
      /* Array email secondarie */
      if (!this.contact.otherContacts.emails) {
        this.contact.otherContacts.emails = [];
      }
      /* Array telefoni secondari */
      if (!this.contact.otherContacts.phones) {
        this.contact.otherContacts.phones = [];
      }
      this.contact.otherContacts.emails[0] = {
        address:
          this.objData.email2 && this.objData.email2 != ""
            ? this.objData.email2
            : ""
      };
      this.contact.otherContacts.emails[1] = {
        address:
          this.objData.email3 && this.objData.email3 != ""
            ? this.objData.email3
            : ""
      };
      this.contact.otherContacts.phones[0] = {
        phoneAreaCode:
          this.objData.phoneAreaCode2 && this.objData.phoneAreaCode2 != ""
            ? this.objData.phoneAreaCode2
            : "+39",
        phoneNumber:
          this.objData.phoneNumber2 && this.objData.phoneNumber2 != ""
            ? this.objData.phoneNumber2
            : ""
      };
      this.contact.otherContacts.phones[1] = {
        phoneAreaCode:
          this.objData.phoneAreaCode3 && this.objData.phoneAreaCode3 != ""
            ? this.objData.phoneAreaCode3
            : "+39",
        phoneNumber:
          this.objData.phoneNumber3 && this.objData.phoneNumber3 != ""
            ? this.objData.phoneNumber3
            : ""
      };
      this.$emit("save", this.objData);
    }
  },
  components: {},
  created() {
    /* Nome azienda*/
    if (this.contact.type == 2) {
      this.objData.name = this.contact.firstName;
    } else {
      this.objData.name = this.contact.company;
    }
    /* Id spiaggia */
    if (
      this.contact.otherInformations.beachTabs &&
      this.contact.otherInformations.beachTabs.length > 0
    ) {
      this.objData.beachId = this.contact.otherInformations.beachTabs[0];
    }
    if (this.contact.email && this.contact.email != "") {
      this.objData.email = this.contact.email;
    }
    if (
      this.contact.otherContacts &&
      this.contact.otherContacts.emails &&
      this.contact.otherContacts.emails[0] &&
      this.contact.otherContacts.emails[0]["address"] &&
      this.contact.otherContacts.emails[0]["address"] != ""
    ) {
      this.objData.email2 = this.contact.otherContacts.emails[0]["address"];
    }
    if (
      this.contact.otherContacts &&
      this.contact.otherContacts.emails &&
      this.contact.otherContacts.emails[1] &&
      this.contact.otherContacts.emails[1]["address"] &&
      this.contact.otherContacts.emails[1]["address"] != ""
    ) {
      this.objData.email3 = this.contact.otherContacts.emails[1]["address"];
    }
    if (
      this.contact.phoneAreaCode &&
      this.contact.phoneAreaCode != "" &&
      this.contact.phoneNumber &&
      this.contact.phoneNumber != ""
    ) {
      this.objData.phoneAreaCode = this.contact.phoneAreaCode;
      this.objData.phoneNumber = this.contact.phoneNumber;
    }
    if (
      this.contact.otherContacts &&
      this.contact.otherContacts.phones &&
      this.contact.otherContacts.phones[0] &&
      this.contact.otherContacts.phones[0]["phoneAreaCode"] &&
      this.contact.otherContacts.phones[0]["phoneAreaCode"] != "" &&
      this.contact.otherContacts.phones[0]["phoneNumber"] &&
      this.contact.otherContacts.phones[0]["phoneNumber"] != ""
    ) {
      this.objData.phoneAreaCode2 = this.contact.otherContacts.phones[0][
        "phoneAreaCode"
      ];
      this.objData.phoneNumber2 = this.contact.otherContacts.phones[0][
        "phoneNumber"
      ];
    }
    if (
      this.contact.otherContacts &&
      this.contact.otherContacts.phones &&
      this.contact.otherContacts.phones[1] &&
      this.contact.otherContacts.phones[1]["phoneAreaCode"] &&
      this.contact.otherContacts.phones[1]["phoneAreaCode"] != "" &&
      this.contact.otherContacts.phones[1]["phoneNumber"] &&
      this.contact.otherContacts.phones[1]["phoneNumber"] != ""
    ) {
      this.objData.phoneAreaCode3 = this.contact.otherContacts.phones[1][
        "phoneAreaCode"
      ];
      this.objData.phoneNumber3 = this.contact.otherContacts.phones[1][
        "phoneNumber"
      ];
    }
    if (this.contact.website) {
      this.objData.website = this.contact.website;
    }
    if (this.contact.otherInformations.addressStreet) {
      this.objData.addressStreet = this.contact.otherInformations.addressStreet;
    }
    if (this.contact.otherInformations.addressNumber) {
      this.objData.addressNumber = this.contact.otherInformations.addressNumber;
    }
    if (this.contact.otherInformations.addressCity) {
      this.objData.addressCity = this.contact.otherInformations.addressCity;
    }
    if (this.contact.otherInformations.addressZip) {
      this.objData.addressZip = this.contact.otherInformations.addressZip;
    }
    if (this.contact.otherInformations.addressState) {
      this.objData.addressState = this.contact.otherInformations.addressState;
    }
    if (this.contact.otherInformations.addressCountry) {
      this.objData.addressCountry = this.contact.otherInformations.addressCountry;
    }
    if (!this.objData.addressCountry || this.objData.addressCountry == "") {
      this.objData.addressCountry = "it";
    }
    if (!this.objData.phoneAreaCode || this.objData.phoneAreaCode == "") {
      this.objData.phoneAreaCode = "+39";
    }
    if (!this.objData.phoneAreaCode2 || this.objData.phoneAreaCode2 == "") {
      this.objData.phoneAreaCode2 = "+39";
    }
    if (!this.objData.phoneAreaCode3 || this.objData.phoneAreaCode3 == "") {
      this.objData.phoneAreaCode3 = "+39";
    }
  }
};
</script>
 
<style lang="scss" scoped>
.add {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-top: -3px;
  margin-left: 4px;
  cursor: pointer;
}
.input-row {
  padding: 0 5px;
  margin-bottom: 5px;
  align-items: center;
}
// .input-elem {

// }
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.detail-row {
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 10px;

  & img {
    margin: 0 30px 0 10px;
  }
}
</style>
 